import actions from './actions'
import mutations from './mutations'
import state from './state'

export const applicationAppointment = {
  actions,
  mutations,
  namespaced: true,
  state
}
